import { gql } from '@apollo/client';

export const docsByUser = gql/* GraphQL */ `
query DocsByUser(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelAgendaDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: ID!
) {
  docsByUser(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      comId
      createdAt
      deleted
      docId
      name
      path
      type
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const updateAgendaDocument = gql/* GraphQL */ `
mutation UpdateAgendaDocument(
  $condition: ModelAgendaDocumentConditionInput
  $input: UpdateAgendaDocumentInput!
) {
  updateAgendaDocument(condition: $condition, input: $input) {
    comId
    createdAt
    deleted
    docId
    name
    path
    type
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    __typename
  }
}
`;